/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    MoyaContainer.register('ext.iconbox', function () {
        return {
            init: IconBox.create,
        };
    });
    var IconBox = /** @class */ (function () {
        function IconBox() {
        }
        IconBox.create = function () {
            return new IconBox().run();
        };
        IconBox.prototype.run = function () {
            this.updateSvgIcons();
        };
        IconBox.prototype.updateSvgIcons = function () {
            document.querySelectorAll('.icon__box .icon.svg').forEach(function (el) {
                var icon = el.dataset.icon;
                if (icon) {
                    var iconSpan = document.createElement('span');
                    iconSpan.setAttribute('style', "-webkit-mask: url('/static/files/icons/" + icon + ".svg') no-repeat;");
                    el.appendChild(iconSpan);
                }
            });
        };
        return IconBox;
    }());

    exports.IconBox = IconBox;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
